export const legends = [
  {
    name: 'AVAILABLE',
    nodeColor: '#00AF53'
  },
  {
    name: 'UNAVAILABLE',
    nodeColor: '#CC3B2C'
  },
  {
    name: 'DEGRADED',
    nodeColor: '#F2AC33'
  },
  {
    name: 'NO DATA',
    nodeColor: '#c0c0c0'
  }
];
